import React from 'react'
import { css } from '@emotion/react'
import { IcomoonIcon } from '../../../atoms/IcomoonIcon'
import { colors } from 'plume-ui'

type Props = {
  children: React.ReactNode
  name: string
  value: string
  checked: boolean
  handler: (e: React.ChangeEvent<HTMLInputElement>) => void
}

export const CheckBox: React.FC<Props> = (props) => {
  return (
    <li>
      <label
        css={css`
          color: ${colors.gray90};
          font-size: 13px;
          line-height: 20px;
          padding: 5px 10px 5px 25px;
          position: relative;
          margin: 0;
          display: block;
          :hover {
            background-color: ${colors.gray40};
            cursor: pointer;
          }
        `}
      >
        {props.checked ? (
          <IcomoonIcon
            name="check1"
            css={css`
              text-indent: -15px;
              display: inline-block;
            `}
          />
        ) : null}
        <input
          type="checkbox"
          name={props.name}
          value={props.value}
          onChange={props.handler}
          checked={props.checked}
          css={css`
            &[type='checkbox'] {
              display: none;
            }
          `}
        />
        {props.children}
      </label>
    </li>
  )
}
